<template>
    <div>
        <div v-if="displayType === 'table'">
            <whos-involved-app-table :orgs="sortedOrgs" :org-heading="orgHeading" :is-provider-list="orgHeading && orgHeading.toLowerCase().includes('provider')" :sort-by="currentSort.sortBy" :sort-order="currentSort.direction" @itemClicked="handleZoomView" @columnHeaderClicked="handleSortClick"></whos-involved-app-table>
        </div>
        <div v-else>
            <whos-involved-app-logos :orgs="orgs" @itemClicked="handleZoomView"></whos-involved-app-logos>
        </div>
        <modal :modal-width="'full-width'" :show-modal="openOrgObj !== null" :show-close-button="false" @closeModal="handleModalClose">
            <org-engagement-details v-if="openOrgObj" :org="openOrgObj" :is-in-modal="true" @closeModal="handleModalClose" @prevNextClicked="handlePrevNextClick" :show-prev-next="true" :disable-prev="disableZoomPrev" :disable-next="disableZoomNext"></org-engagement-details>
        </modal>
    </div>
</template>

<script setup>
    import {ref, computed, nextTick, onMounted, watch} from 'vue'
    import Modal from './Modal.vue';
    import OrgEngagementDetails from './OrgEngagementDetails.vue'
    import WhosInvolvedAppTable from './WhosInvolvedAppTable.vue'
    import WhosInvolvedAppLogos from './WhosInvolvedAppLogos.vue'
    
    
    const props = defineProps({
        orgs: Array,
        orgHeading: { type: String, default: null},
        displayType: String,
        returnUrl: String,
    })

    const openOrgIndex = ref(null)
    const currentUrl = ref(null)
    const sortedOrgs = ref([])
    const currentSort = ref({
        sortBy: 'list_as_engaged',
        direction: 'asc'
    })

    watch(() => props.orgs, (newVal, oldVal) =>{
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            sortedOrgs.value = [...newVal];
        }
        updateCurrentUrl()
        handleTableSort();
    });
    
    onMounted(()=>{
        sortedOrgs.value = [...props.orgs];
        updateCurrentUrl()
        handleTableSort()
    })

    const listToPullFrom = computed(()=>{
        return props.displayType === 'table' ? sortedOrgs.value : props.orgs
    })

    const openOrgObj = computed(()=>{
        return openOrgIndex.value === null ? null : listToPullFrom.value[openOrgIndex.value]
    })
    const disableZoomPrev = computed(()=> openOrgIndex.value === 0 )
    const disableZoomNext = computed(()=> openOrgIndex.value >= props.orgs.length - 1 )

    const updateCurrentUrl = () => {
        currentUrl.value = window.location.href;
    }
    
    const getValueByPath = (obj, path) => {
        return path.split('.').reduce((o, k) => (o || {})[k], obj);
    }
    const handleZoomView = (index) => {
        openOrgIndex.value = index
        // openOrgObj.value = props.orgs[index]

        nextTick(()=>{
            let newUrl = '/organization/' + openOrgObj.value.slug
            history.pushState({ customData: openOrgObj.value.name }, '', newUrl);
        })
    }
    const handleModalClose = () => {
        openOrgIndex.value = null
        console.log({'currentUrl.value' : currentUrl.value});
        history.pushState({ customData: 'Who’s Involved?'}, '', props.returnUrl)
    }
    const handlePrevNextClick = (direction) => {
        if(direction === 'prev' && openOrgIndex.value > 0) {
            if(!disableZoomPrev.value) {
                openOrgIndex.value--
            }
        } else if( direction === 'next') {
            if(!disableZoomNext.value) {
                let numItems = props.orgs.length
                if(openOrgIndex.value < numItems) {
                    openOrgIndex.value++
                }
            }
        }
        handleZoomView(openOrgIndex.value)
    }

    /* Handle Sorting Interaction */
    const handleSortClick = (propPath) => {
        console.log({'propPath' : propPath});
        let direction = 'asc'
        if(propPath === currentSort.value.sortBy) {
            direction = currentSort.value.direction === 'asc' ? 'desc' : 'asc'
        }
        currentSort.value = {
            sortBy: propPath,
            direction: direction
        }
        console.log({'currentSort.value' : currentSort.value});
        handleTableSort()
    }
    const handleTableSort = () => {
        let propPath = currentSort.value.sortBy
        let direction = currentSort.value.direction
        // console.log('tablesortcalled');
        switch (propPath) {
            case 'list_as_engaged':
            case 'is_member':
            case 'engagement.badges.transparency.has_badge':
            case 'engagement.badges.resiliency.has_badge':
                sortByBoolean(propPath)
                break;
            case 'engagement.scorecard':
            case 'engagement.bcm_assessment':
            case 'engagement.mapping':
                sortByScore(propPath)
                break
            case 'name':
                sortByTitle(propPath)
            default:
                break;
        }
        if(direction === 'desc') {
            sortedOrgs.value = sortedOrgs.value.reverse()
        }
    }
    const sortByBoolean = (path) => {
        sortedOrgs.value = [...sortedOrgs.value].sort((a, b) => {
            if (getValueByPath(a, path) && !getValueByPath(b, path)) {
                return -1;
            }
            if (!getValueByPath(a, path) && getValueByPath(b, path)) {
                return 1;
            }
            return 0;
        });
    };
    const sortByScore = (path) => {
        console.log({'sortByScore - path' : path});
        const sortOrder = ["engaged", "supportive", "acknowledged", "unresponsive", "declined"]
        sortedOrgs.value.sort((a, b) => {
            return sortOrder.indexOf(getValueByPath(a, path)) - sortOrder.indexOf(getValueByPath(b, path));
        });
        sortedOrgs.value.forEach(org => {
        });
    }
    const sortByTitle = (path) => {
        sortedOrgs.value.sort((a, b) => {
            let nameA = getValueByPath(a, path).replace(/^(the|a|an)\s+/i, '').toLowerCase();
            let nameB = getValueByPath(b, path).replace(/^(the|a|an)\s+/i, '').toLowerCase();

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }

    
</script>
